export default "__VITE_ASSET__D3NOi_U___"